import { makeStyles } from "@material-ui/core/styles";
import { weatherTimeWithID, WX_ID_TROPICALCYCLONE } from "../../../store/WeatherContentsState";
import { useRecoilValue } from "recoil";
import max35Img from "../../../images/contents/map/tropicalstorm/max35.png";
import max50Img from "../../../images/contents/map/tropicalstorm/max50.png";
import tDImg from "../../../images/contents/map/tropicalstorm/TD.png";
import tSImg from "../../../images/contents/map/tropicalstorm/TS.png";
import tYImg from "../../../images/contents/map/tropicalstorm/TY.png";
import xTImg from "../../../images/contents/map/tropicalstorm/XT.png";

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
    // alignItems: 'center',

  },
  item: {
    position: 'relative',
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px'
  },
  iconWrap: {
    display: "inline-block"
  },
  icon: {
    verticalAlign: "middle",
    height: "30px"
  },
  iconMini: {
    height: "20px"
  },
  trackLine:{
    position: 'relative',
    display:  'inline-block',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '30px',
    height: '5px',
    '&:before': {
      position: 'absolute',
      display: 'block',
      content: "''",
      left: 0,
      width: '25px'
    }
  },
  trackActual: {
    '&:before': {
      borderTop: '4px solid #802020'
    }
  },
  trackForecast: {
    '&:before': {
      borderTop: '4px solid #0000ff'
    }
  },
  label: {
    display: "inline-block",
    textAlign: 'left',
    paddingLeft: '5px',
    width:100,
    whiteSpace: 'nowrap'
  }
}));


function LegendSigmet() {
  const classes = useStyles();
  const timeInfo = useRecoilValue(weatherTimeWithID(WX_ID_TROPICALCYCLONE));
  return (
    <div>
      <div className="legend-contents-time">
        {timeInfo.baseTime}
      </div>
      <ul className={classes.box}>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={tDImg} alt="Tropical depression" className={classes.icon}/></span><span className={classes.label}>Tropical depression</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={tSImg} alt="Tropical Storm" className={classes.icon}/></span><span className={classes.label}>Tropical Storm</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={tYImg} alt="Typhoon/Hurricane/Cyclone" className={classes.icon}/></span><span className={classes.label}>Typhoon/Hurricane/Cyclone</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={xTImg} alt="Extra Tropical Low" className={classes.icon}/></span><span className={classes.label}>Extra Tropical Low</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><div className={classes.trackLine + ' ' + classes.trackActual}/></span><span className={classes.label}>Track History</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><div className={classes.trackLine + ' ' + classes.trackForecast}/></span><span className={classes.label}>Forecast Track</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={max35Img} alt="35kt wind Radii" className={classes.icon + " " + classes.iconMini}/></span><span className={classes.label}>35kt wind Radii</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={max50Img} alt="50kt wind Radii" className={classes.icon + " " + classes.iconMini}/></span><span className={classes.label}>50kt wind Radii</span>
        </li>
      </ul>
    </div>
  )
}

export default LegendSigmet;